module.exports = __webpack_public_path__ + "media/images/front/about/e-mediceo/cc_renewal_pc_003-95447a9d34f8e0896ee517ddefe80565.png";